/**
 * Localize-Policy-Currency
 * --------------------------------------------------------------------
 * Konvertiert hartcodierte EUR-Betraege im Body von Shopify-Standard-Policy-Pages
 * (/policies/shipping-policy, /policies/refund-policy etc.) clientseitig in die
 * aktive Market-Currency (USD / CAD / GBP / AUD / CHF = 1:1; NOK = kaufkraft-aequiv.).
 *
 * Warum JS und nicht Liquid: Shopify rendert /policies/* mit einem internen
 * Default-Template, das vom Theme nicht ueberschrieben werden kann.
 *
 * Mapping ist 1:1 identisch mit snippets/localize-currency-text.liquid.
 * Bei neuen Betraegen / Currencies: beide Stellen synchron halten plus
 * snippets/cart-drawer.liquid (Cart-Bar Schwelle in Cents).
 *
 * Symbole:
 *   USD -> $
 *   CAD -> C$ (eindeutig, verhindert Verwechslung mit USD)
 *   GBP -> £
 *   AUD -> A$ (eindeutig, verhindert Verwechslung mit USD)
 *   CHF -> 'CHF ' (Prefix mit Space)
 *   NOK -> 'kr' Suffix, skalierte Betraege (149->1 690 kr usw.)
 */
(function () {
  'use strict';

  // Nur auf /policies/* URLs aktivieren
  if (!/\/policies\//.test(window.location.pathname)) return;

  // Aktive Currency ermitteln: Shopify.currency.active ist von Shopify Markets gesetzt
  var activeCurrency =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    '';

  // Symbol-Mapping pro Currency (Prefix-Symbol). Null = nicht unterstuetzt (Snippet greift dann nicht).
  // NOK wird separat behandelt: Suffix 'kr' + kaufkraft-aequivalente Betraege (nicht 1:1).
  var symbolMap = {
    USD: '$',
    CAD: 'C$',
    GBP: '£',
    AUD: 'A$',
    CHF: 'CHF '
  };

  // Reihenfolge in den Mappings: laengstes Pattern zuerst (sonst Substring-Bug).
  // \s* deckt normale Spaces + non-breaking spaces ab. [,.] matched Komma ODER Punkt.
  var mappings;
  if (activeCurrency === 'NOK') {
    // NOK: kein 1:1-Mapping (149 NOK waeren nur ~13 EUR). Gerundete kaufkraft-aequivalente
    // Betraege, Symbol 'kr' als Suffix. Muss synchron zu snippets/localize-currency-text.liquid
    // (when 'NOK') und der Cart-Bar-Schwelle (169000 Cent) bleiben.
    mappings = [
      // Dezimal-Betraege Symbol hinten
      [/149[,.]00\s*€/g, '1 690 kr'],
      [/189[,.]00\s*€/g, '2 190 kr'],
      [/249[,.]00\s*€/g, '2 890 kr'],
      [/19[,.]90\s*€/g, '229 kr'],
      [/5[,.]90\s*€/g, '69 kr'],
      // Dezimal-Betraege Symbol vorne
      [/€\s*149[,.]00/g, '1 690 kr'],
      [/€\s*189[,.]00/g, '2 190 kr'],
      [/€\s*249[,.]00/g, '2 890 kr'],
      [/€\s*19[,.]90/g, '229 kr'],
      [/€\s*5[,.]90/g, '69 kr'],
      // Ganzzahlen Symbol hinten (laengste zuerst!)
      [/249\s*€/g, '2 890 kr'],
      [/189\s*€/g, '2 190 kr'],
      [/149\s*€/g, '1 690 kr'],
      [/50\s*€/g, '590 kr'],
      [/10\s*€/g, '119 kr'],
      // Ganzzahlen Symbol vorne
      [/€\s*249/g, '2 890 kr'],
      [/€\s*189/g, '2 190 kr'],
      [/€\s*149/g, '1 690 kr'],
      [/€\s*50/g, '590 kr'],
      [/€\s*10/g, '119 kr']
    ];
  } else {
    var symbol = symbolMap[activeCurrency];
    if (!symbol) return;
    // Mappings dynamisch generieren basierend auf aktuellem Symbol (Prefix).
    mappings = [
      // Dezimal-Betraege Symbol hinten
      [/149[,.]00\s*€/g, symbol + '149'],
      [/189[,.]00\s*€/g, symbol + '189'],
      [/249[,.]00\s*€/g, symbol + '249'],
      [/19[,.]90\s*€/g, symbol + '19.90'],
      [/5[,.]90\s*€/g, symbol + '5.90'],
      // Dezimal-Betraege Symbol vorne
      [/€\s*149[,.]00/g, symbol + '149'],
      [/€\s*189[,.]00/g, symbol + '189'],
      [/€\s*249[,.]00/g, symbol + '249'],
      [/€\s*19[,.]90/g, symbol + '19.90'],
      [/€\s*5[,.]90/g, symbol + '5.90'],
      // Ganzzahlen Symbol hinten (laengste zuerst!)
      [/249\s*€/g, symbol + '249'],
      [/189\s*€/g, symbol + '189'],
      [/149\s*€/g, symbol + '149'],
      [/50\s*€/g, symbol + '50'],
      [/10\s*€/g, symbol + '10'],
      // Ganzzahlen Symbol vorne
      [/€\s*249/g, symbol + '249'],
      [/€\s*189/g, symbol + '189'],
      [/€\s*149/g, symbol + '149'],
      [/€\s*50/g, symbol + '50'],
      [/€\s*10/g, symbol + '10']
    ];
  }

  function localizeTextNodes(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var original = node.nodeValue;
      if (!original || original.indexOf('€') === -1) continue;
      var replaced = original;
      for (var i = 0; i < mappings.length; i++) {
        replaced = replaced.replace(mappings[i][0], mappings[i][1]);
      }
      if (replaced !== original) node.nodeValue = replaced;
    }
  }

  function run() {
    // Shopify rendert /policies/* in einen Container mit Klasse .shopify-policy__container
    // bzw. .shopify-policy__body. Falls Theme das umschliesst, fallback auf main/role=main.
    var candidates = document.querySelectorAll(
      '.shopify-policy__container, .shopify-policy__body, .rte'
    );
    if (candidates.length > 0) {
      for (var i = 0; i < candidates.length; i++) {
        localizeTextNodes(candidates[i]);
      }
    } else {
      // Fallback: kompletter main-Bereich. Text-Nodes ohne '€' werden uebersprungen
      // (siehe localizeTextNodes), daher safe gegen Doppel-Conversion bei bereits
      // konvertierten Stellen (z.B. Top-Bar).
      var main = document.querySelector('main, [role="main"]') || document.body;
      localizeTextNodes(main);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
